import * as React from 'react'
import classNames from 'classnames'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'

interface Props {
    deps: CommonDeps
    leftButton?: () => React.ReactElement<unknown>
    rightButton?: () => React.ReactElement<unknown>
    bordered?: boolean
    dark?: boolean
    children?: () => React.ReactElement<unknown>
}

export class TopBar extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    public tryRender = () => {
        const { children, leftButton, rightButton } = this.props

        return (
            <div
                className={classNames('AppCore__page__TopBar', {
                    bordered: this.props.bordered !== false,
                    dark: this.props.dark,
                })}
            >
                <div className={classNames('AppCore__page__TopBar__button', 'left')}>
                    {leftButton && renderCatch(this.props.deps, leftButton)}
                </div>
                <div className="AppCore__page__TopBar__content">
                    {children && renderCatch(this.props.deps, children)}
                </div>
                <div className={classNames('AppCore__page__TopBar__button', 'right')}>
                    {rightButton && renderCatch(this.props.deps, rightButton)}
                </div>
            </div>
        )
    }
}
